import { Alert, CircularProgress } from '@mui/material'
import AppTable from 'components/AppTable/AppTable'
import { useRemoteResource } from 'hooks/useRemoteResource'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import customersService from 'services/admin/customersService'
import { expiredInDays } from 'helpers/dateHelper'

export const ExpiredVisas = () => {
    const columnConfig = [
        {
            label: '#',
            render: (v, index) => `${index + 1}`
        },
        {
            key: 'customer.name',
            label: 'Клиент',
            render: (i) => <Link className='color-blue' to={`/admin/customers/view/${i.customer.id}`}>
                {i.customer.lastName} {i.customer.firstName}
            </Link>
        },
        {
            key: 'type',
            label: 'Тип документа',
            render: (i) => <span>Туристическая</span>
        },
        {
            key: 'expiredAt',
            label: 'Срок истечения',
            render: (i) => `${i.expiredAt} (${expiredInDays(i.expiredAt)})`
        },
    ]

    const [expiredDocuments, loadData, loading, error] = useRemoteResource(() => customersService.getExpiredVisas({}))

    console.log(`unpaidClients:`, expiredDocuments);

    return loading ? <div className="text-center"><CircularProgress></CircularProgress></div> :
        <div>
            <h3 className='m-b-16'>Просроченные визы</h3>
            <Alert className='m-b-32' color='info'>В данном разделе или списке показаны документы, у которых срок действия подходит к концу,
                и их необходимо обновить или продлить в ближайшее время.</Alert>
            <AppTable data={expiredDocuments} columnConfig={columnConfig}></AppTable>
        </div>
}
